import { useSelector, shallowEqual } from 'react-redux';

import { useMeterType } from 'hooks/useMeterType';
import { selectFuelType } from 'state/fuel-type/fuel-type-slice';

export const useIsNewToBrand = () => {
  const fuelType = useSelector(selectFuelType, shallowEqual);
  const { gas, electric } = fuelType;

  const {
    isBGCustomerForElec,
    isBGCustomerForGas,
    isBGECustomerForElec,
    isBGECustomerForGas
  } = useMeterType();

  const gasOnly = gas && !electric;
  const electricOnly = electric && !gas;

  switch (true) {
    case gasOnly:
      return !isBGCustomerForGas && !isBGECustomerForGas;
    case electricOnly:
      return !isBGCustomerForElec && !isBGECustomerForElec;
    default:
      return (
        !isBGCustomerForGas &&
        !isBGECustomerForGas &&
        !isBGCustomerForElec &&
        !isBGECustomerForElec
      );
  }
};
